import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import {
  PermissionLevel,
  PermissionsEnum,
  TOAST_IDS,
  ToastType,
} from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { useArchiveTrack } from "@/modules/property-tracks/hooks/archive-track/archive-track.hook";
import { MenuItem } from "@mui/material";
import { Archive } from "lucide-react";
import { useState } from "react";

interface ArchiveTrackMenuItemProps {
  track: {
    uid: string;
    archivedAt?: Date;
  };
}

export default function ArchiveTrackMenuItem({
  track,
}: ArchiveTrackMenuItemProps) {
  if (track.archivedAt) return;

  const [open, setOpen] = useState(false);

  const mutation = useArchiveTrack();

  const handleSubmit = () => {
    mutation.mutate(
      { uid: track.uid },
      {
        onSuccess: () => {
          showToast({
            type: ToastType.SUCCESS,
            message: "Track archived successfully",
            toastId: TOAST_IDS.ARCHIVE_TRACK_SUCCESS,
          });
        },
        onError: (error) => {
          showToast({
            type: ToastType.ERROR,
            message:
              error?.response?.data?.message ||
              "Unexpected error occurred. Please try again.",
            toastId: TOAST_IDS.ARCHIVE_TRACK_ERROR,
          });
        },
      }
    );
  };

  return (
    <PermissionGuard
      permissions={[
        {
          name: PermissionsEnum.ARCHIVE_TRACK,
          level: PermissionLevel.WRITE,
        },
      ]}
    >
      <MenuItem
        sx={(t) => ({
          display: "flex",
          alignItems: "center",
          gap: t.nawy.spacing.sm,
          color: t.nawy.colors.semantic.text.extension.negative,
        })}
        onClick={() => setOpen(true)}
      >
        <Archive /> Archive Track
      </MenuItem>

      <ConfirmationModal
        open={open}
        setOpen={setOpen}
        onConfirmHandler={handleSubmit}
        title="Archive Track"
        body="Are you sure you want to archive this track? Archiving will auto unassign this track from its current user"
        isLoading={mutation.isPending}
      />
    </PermissionGuard>
  );
}
